module.exports = __webpack_public_path__ + "static/media/itunes.dcfbdbe0.svg";